export const noCommentProvidedMessage = 'No comment provided';
